import React from "react";
import './Alerts.css';

export default function Alert(props) {
   
  function handleClose(e)
  {
    e.target.parentElement.style.display = "none";
  }
  return (
    <>
      {props.alertType === "error" && (
        <div
          id="alertDanger"
          className={props.class +" alert alert-danger alert-dismissible fade show alertDanger errorborder alertZindex"}
        >
          <div className="d-flex align-items-center">
          <span className="material-icons-round me-2 erroricon"> Error </span>
            <strong className="me-2 font-18" style={{ color: "#bc272e" }}>
              Error!
            </strong>
          </div>
          <p className="mb-0 dangertext"> {props.alertMsg}</p>
          <a className="btn-close ms-2 btn-closeAlert" onClick={(e) =>handleClose(e) }> </a>
        </div>
      )}
      {props.alertType === "warning" && (
        <div
          id="alertDanger"
          className={props.class + " alert alert-warning alert-dismissible fade show alertWarning dangerborder alertZindex"}
        >
          <div className="d-flex align-items-center">
            <span className="material-icons me-2 warningicon" style={{ color: "#c09853" }}>warning</span>
            <strong className="me-2 font-18" style={{ color: "#c09853" }}>
            Warning!
            </strong>
          </div>
          <p className="mb-0 dangertext"> {props.alertMsg}</p>
          <a className="btn-close ms-2 btn-closeAlert" onClick={(e) =>handleClose(e) }> </a>
        </div>
      )}
      {props.alertType === "sucess" && (
        <div id="alertSucess" className={props.class + " alert alert-sucess alert-dismissible fade show alertSuccess alertZindex"}>
          <div className="d-flex align-items-center">
            <span className="material-icons me-2 successicon">check_circle</span>
            <strong className="me-2 font-18" style={{ color: "#3ab16d" }}>
              Success!
            </strong>
          </div>
          <p className="mb-0 dangertext">
          {props.alertMsg}
          </p>
          <a className="btn-close btn-closeAlert" onClick={(e) =>handleClose(e) }> </a>
        </div>
      )}
    </>
  );
}
